import { render, staticRenderFns } from "./Uniform.vue?vue&type=template&id=23ab3bb7&scoped=true"
import script from "./Uniform.vue?vue&type=script&lang=js"
export * from "./Uniform.vue?vue&type=script&lang=js"
import style0 from "./Uniform.vue?vue&type=style&index=0&id=23ab3bb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab3bb7",
  null
  
)

export default component.exports